import React from 'react';
import { ArrowRight } from 'lucide-react';
import { ARTICLES } from '@/lib/content';
import SEO from '@/components/SEO';

export default function Articles() {
    const [feature, ...rest] = ARTICLES;
    return (
        <div className="pt-32 bg-white">
            <SEO title="Articles" description="Field notes from the broadcast trenches — practical playbooks for automotive dealerships." path="/articles" />
            <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-12">
                <div className="text-xs uppercase tracking-[0.35em] font-bold text-brand-orange mb-5">
                    Articles
                </div>
                <h1 className="font-display font-black text-brand-navy text-5xl md:text-7xl lg:text-8xl tracking-tight leading-[0.95] max-w-5xl">
                    Field notes from<br />
                    <span className="italic font-medium text-brand-orange">the broadcast trenches.</span>
                </h1>
            </section>

            <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-20">
                <article className="grid lg:grid-cols-12 gap-8 border-t border-brand-navy/15 pt-12">
                    <div className="lg:col-span-7">
                        <div className="aspect-[16/10] overflow-hidden">
                            <img src={feature.image} alt={feature.title} className="w-full h-full object-cover" />
                        </div>
                    </div>
                    <div className="lg:col-span-5 flex flex-col justify-center">
                        <div className="text-[11px] uppercase tracking-[0.3em] text-brand-orange mb-4 font-bold">
                            Featured · {feature.date} · {feature.readTime}
                        </div>
                        <h2 className="font-display font-extrabold text-3xl md:text-4xl lg:text-[44px] text-brand-navy tracking-tight leading-tight mb-5">
                            {feature.title}
                        </h2>
                        <p className="text-brand-navy/70 text-base md:text-lg leading-relaxed mb-6">
                            {feature.excerpt}
                        </p>
                        <a
                            href="#"
                            className="inline-flex items-center gap-3 self-start bg-brand-navy text-white hover:bg-brand-orange px-6 py-3 text-xs font-bold uppercase tracking-[0.25em] transition-colors"
                        >
                            Read article <ArrowRight className="w-4 h-4" />
                        </a>
                    </div>
                </article>
            </section>

            <section className="bg-brand-cream py-14 md:py-18 lg:py-20">
                <div className="max-w-[1400px] mx-auto px-6 md:px-10">
                    <h3 className="font-display font-extrabold text-3xl md:text-4xl text-brand-navy tracking-tight mb-10">
                        More reading
                    </h3>
                    <div className="grid md:grid-cols-2 gap-6">
                        {rest.map((a) => (
                            <article key={a.slug} className="bg-white border border-brand-navy/10 hover:border-brand-orange hover:shadow-[0_20px_50px_-20px_rgba(31,27,77,0.2)] transition-all group">
                                <div className="aspect-[16/10] overflow-hidden">
                                    <img
                                        src={a.image}
                                        alt={a.title}
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                                    />
                                </div>
                                <div className="p-7">
                                    <div className="text-[11px] uppercase tracking-[0.25em] text-brand-orange mb-3 font-bold">
                                        {a.date} · {a.readTime}
                                    </div>
                                    <h4 className="font-display font-extrabold text-2xl text-brand-navy mb-3 leading-tight group-hover:text-brand-orange transition-colors">
                                        {a.title}
                                    </h4>
                                    <p className="text-brand-navy/65 leading-relaxed">{a.excerpt}</p>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
